import React, { useEffect, useState } from 'react';
import ClientPolicyItem from './_ClientPolicyItem';
import { Button, Dropdown, MenuProps, Popover } from 'antd';

type Props = {
    data: any;    
    config?: any;
    actions?: any;
    showAddTreatmentPopup: (type: number) => void;
    customerData: any;
};

const SelectCollumnsPopOver = (props: any) => {
    const [optionsList, setOptionsList] = useState<any[]>([]);

    const buildOptionslist = () => {
        const collumnsNames = Object.keys(props.options);
        const rows: any[] = [];
        collumnsNames.forEach((collumn: string, key: number) => {
            rows.push({
                label: props.options[collumn].label,
                value: collumn,
                checked: !props.options[collumn].hidden
            });
        });
        setOptionsList(rows);

    }

    const onCheck = (optionValue: string) => {
        //console.log('SelectCollumnsPopOver onCheck', optionValue);
        if (props.onCheck) {
            const opts = props.options;
            opts[optionValue].hidden = !opts[optionValue].hidden
            props.onCheck(opts)
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect(()=>{
        buildOptionslist();
    }, [props.options]);

    useEffect (()=>{
        buildOptionslist();
    }, []);

    return (
        <div>
        {optionsList.map((option: any, index: number)=>{
            return (
                <div key={index} className='flex-start flex-reverse'>
                    <input type='checkbox' onChange={()=>onCheck(option.value)} />
                    <div>
                    {option.label}
                    </div>
                </div>
            )
        })}
        <a onClick={onClose}>Close</a>

        </div>
    )
}

const ClientPolicyTable = (props: Props) => {
    // const [policy, setPolicy] = useState<any | null>(null);
    const [policiesList, setPoliciesList] = useState<any[]>([]);
    const [selectedPolicy, setSelectedPolicy] = useState<string | null>(null);
    const [addCollumnsItems, setCollumnsItems] = useState<MenuProps['items']>([]);
    const [additionalColumns, setAdditionalColumns] = useState<any>({
        seniority: {
            hidden: true,
            label: 'ותק'
        },
        numberOfDrivers:  {
            hidden: true,
            label: 'מספר נהגים', 
        },
        regular:  {
            hidden: true,
            label: 'רגיל', 
        },
        selected:  {
            hidden: true,
            label: 'נבחר', 
        },
    });
    const [showDropDown, setShowDropDown] = useState(false);

    const onSelectPolicy = (id: string | null) => {
        if (props.actions && props.actions.onSelectPolicy && typeof(props.actions.onSelectPolicy) == 'function') {
            props.actions.onSelectPolicy(id)
        }
    }
    const onClaimCreate = (id: string | null, data?: any) => {
        if (props.actions && props.actions.onClaimCreate && typeof(props.actions.onClaimCreate) == 'function') {
            props.actions.onClaimCreate(id, data)
        }
    }

    const buildCollumnsMenu = () =>{
        const collumnsNames = Object.keys(additionalColumns);
        setCollumnsItems([]);
        const collumns: MenuProps['items'] = [];
        collumnsNames.forEach((collumn: string, key: number) => {
            collumns.push({
                    key: `${key}`,
                    label: (
                        <>
                        <div className='flex-start'>
                            <input type='checkbox' checked={!additionalColumns[collumn].hidden ? true : false} /> {additionalColumns[collumn].label}
                        </div>
                        </>
                    )
            })
        });
        return (
            <>
            <div>asdsdsd</div>
            </>
        )
        // setCollumnsItems(collumns);
    }

    const hide = () => {
        //console.log('onMenuOptionChange hide')
      setShowDropDown(false);
    };
  
    const handleOpenChange = (newOpen: boolean) => {
        setShowDropDown(newOpen);
        //console.log('onMenuOptionChange hide', newOpen)
    };

    const onMenuOptionChange = (options: any) => {
        //console.log('onMenuOptionChange', options)
        setAdditionalColumns(options)
    }
    
    const emptyFunc = () => {}

    useEffect(()=>{
        if (props.data && props.data.items && props.data.items.length > 0) {
            // every item is array of policy items, sort every item by the field additionalNumber
            let policyItems: any[] = [];
            props.data.items.forEach((item: any[])=>{
                policyItems.push(item.sort((a: any, b: any)=> b.additionNumber - a.additionNumber ));
            });
            console.log('policyItems', policyItems)
            setPoliciesList(policyItems);
        } else {
            setPoliciesList([]);
        }

        if (props.data && props.data.selected  && props.data.selected !== null ) {
            setSelectedPolicy(props.data.selected);
        } else {
            setSelectedPolicy(null);
        }
        //console.log('ClientPolicyTable useEffect [props.data]', props)
    },[props.data]);

    useEffect(()=>{
        //console.log('ClientPolicyTable useEffect []', props);
        // setCollumnsItems([
        //     {
        //         key: '1',
        //         label: (
        //             <li className="pointer rtl"
        //                 onClick={()=>{emptyFunc}}
        //             >
        //                 הורד קובץ
        //             </li>
        //         )
        //     }
        // ])
        // buildCollumnsMenu()
    },[]);

    return(<>
    <div className='policy-details-table'>
        <div className='content-header'>
            <div className="content-table-header flex-centered">
                <div className='cell icon policy-icon'>

                </div>
                <div className="cell short policy-type" style={{marginRight: '5px'}}>
                סוג פוליסה
                </div>
                <div className="cell short policy-number">
                מס' פוליסה
                </div>
                <div className="cell short insurance-branch">
                ענף
                </div>
                <div className="cell short insurance-company">
                חברת ביטוח
                </div>
                <div className="cell short start-date">
                מתאריך
                </div>
                <div className="cell short end-date">
                עד תאריך
                </div>
                <div className="cell short insurance-type">
                סוג ביטוח
                </div>
                <div className="cell short vechicle-number">
                מספר רישוי
                </div>
                <div className="cell short car-year">
                שנה
                </div>
                <div className="cell short vechicle-name">
                הנכס
                </div>
                <div className="cell short premium">
                פרמיה
                </div>
                <div className="cell short hammer-icon">
                תביעה
                </div>
                <div className={`cell short program-name ${additionalColumns.seniority.hidden ? 'hide' : ''}`}>
                ותק
                </div>
                <div className={`cell short model-code ${additionalColumns.numberOfDrivers.hidden ? 'hide' : ''}`}>
                מספר נהגים
                </div>
                <div className={`cell short creation-date ${additionalColumns.regular.hidden ? 'hide' : ''}`}>
                רגיל
                </div>
                <div className={`cell short creation-date ${additionalColumns.selected.hidden ? 'hide' : ''}`}>
                נבחר
                </div>
                <div className="cell short hide approved-drivers">
                רשאים לנהוג 
                </div>
                <div className="cell short hide driver-ages">
                גילאי נהגים 
                </div>
                <div className="cell short hide agent">
                סוכן
                </div>
                <div className="cell short hide road-service-provider">
                ספק שרותי דרך  
                </div>
                <div className="cell short hide property-address">
                כתובת הנכס 
                </div>
                <div className="cell short hide branch-name">
                שם הענף
                </div>
                <div className="cell short hide policy-status">
                סטטוס פוליסה (בחיים)
                </div>
                <div className="cell short hide pos-stand">
                מעמד קופה (שוק ההון)
                </div>
                <div className="cell short hide pos-balance">
                יתרת קופה (שוק ההון)
                </div>
                <div className="cell short hide cash-register-route">
                קופה/ מסלול (שוק ההון)
                </div>
                <div className="cell short hide employer-name">
                שם המעסיק (שוק ההון)
                </div>
                
                <div className="cell actions">
                    {/* <Dropdown menu={{ items: addCollumnsItems }} trigger={['click']}>
                        <div className='icon add black pointer'></div>
                    </Dropdown> */}
                    <Popover
                        placement="bottom"
                        content={<SelectCollumnsPopOver options={additionalColumns} onCheck={(opts: any)=>onMenuOptionChange(opts)} onHide={()=>handleOpenChange(false)} />}
                        title="Title"
                        trigger="click"
                        open={showDropDown}
                        onOpenChange={handleOpenChange}
                    >
                    <div className='icon add black pointer'></div>
                    </Popover>
                </div>
            </div>
        </div>
        <div className='content-data-table'>
            {policiesList ? (<>
                {policiesList.map((policyItem: any[])=> {
                    return (
                        <>
                    <ClientPolicyItem
                        isSelected={policyItem[0] && selectedPolicy==policyItem[0].subscriberNumber}
                        policyItems={policyItem} config={{
                            additionalColumns: additionalColumns,
                            onSelectPolicy: (id: string | null)=>onSelectPolicy(id),
                            onClaimCreate: (id: string | null, data?: any)=>onClaimCreate(id, data),
                            showMessagePopup: (message: string)=> props.config.showMessagePopup ? props.config.showMessagePopup(message) : emptyFunc(),
                            displayFile: (file: any) => props.config.displayFile ? props.config.displayFile(file) : emptyFunc(),
                        }} 
                        showAddTreatmentPopup={props.showAddTreatmentPopup}
                        customerData={props.customerData}
                    />
                        </>
                    )
                })}
            </>) : (<></>)}
            {props.data.riders ? (<>
                {props.data.riders.map((policyItem: any[])=> {
                    return (
                        <>
                    <ClientPolicyItem
                        isSelected={policyItem[0] && selectedPolicy==policyItem[0].subscriberNumber}
                        policyItems={policyItem} config={{
                            additionalColumns: additionalColumns,
                            onSelectPolicy: (id: string | null)=>onSelectPolicy(id),
                            onClaimCreate: (id: string | null, data?: any)=>onClaimCreate(id, data),
                            showMessagePopup: (message: string)=> props.config.showMessagePopup ? props.config.showMessagePopup(message) : emptyFunc(),
                            displayFile: (file: any) => props.config.displayFile ? props.config.displayFile(file) : emptyFunc(),
                        }} 
                        showAddTreatmentPopup={props.showAddTreatmentPopup}
                        customerData={props.customerData}
                    />
                        </>
                    )
                })}
            </>) : (<></>)}
        </div>
        
    </div>
    </>)
}
export default ClientPolicyTable;